<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="$i18n.locale = localeObj.locale"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
    locales() {
      /* eslint-disable global-require */
      return [
        {
          locale: 'en',
          img: require('@/assets/images/flags/en.png'),
          name: this.$t('English'),
        },
        {
          locale: 'fr',
          img: require('@/assets/images/flags/fr.png'),
          name: this.$t('French'),
        },
        {
          locale: 'cn',
          img: require('@/assets/images/flags/cn.svg'),
          name: this.$t('Chinese'),
        },
        {
          locale: 'de',
          img: require('@/assets/images/flags/de.svg'),
          name: this.$t('German'),
        },
        {
          locale: 'es',
          img: require('@/assets/images/flags/es.svg'),
          name: this.$t('Spanish'),
        },
        {
          locale: 'jp',
          img: require('@/assets/images/flags/jp.png'),
          name: this.$t('Japanese'),
        },
        {
          locale: 'ko',
          img: require('@/assets/images/flags/ko.png'),
          name: this.$t('Korean'),
        },
        {
          locale: 'nl',
          img: require('@/assets/images/flags/nl.svg'),
          name: this.$t('Dutch'),
        },
      ]
    },
  },
}
</script>

<style>

</style>
